var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertRed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9999 9.15729L32.5499 30.8406H7.44988L19.9999 9.15729V9.15729ZM4.56654 29.174C3.28321 31.3906 4.88321 34.174 7.44988 34.174H32.5499C35.1165 34.174 36.7165 31.3906 35.4332 29.174L22.8832 7.49062C21.5999 5.27396 18.3999 5.27396 17.1165 7.49062L4.56654 29.174ZM18.3332 17.5073V22.5073C18.3332 23.424 19.0832 24.174 19.9999 24.174C20.9165 24.174 21.6665 23.424 21.6665 22.5073V17.5073C21.6665 16.5906 20.9165 15.8406 19.9999 15.8406C19.0832 15.8406 18.3332 16.5906 18.3332 17.5073ZM18.3332 27.5073C18.3332 26.5868 19.0794 25.8406 19.9999 25.8406V25.8406C20.9204 25.8406 21.6665 26.5868 21.6665 27.5073V27.5073C21.6665 28.4278 20.9204 29.174 19.9999 29.174V29.174C19.0794 29.174 18.3332 28.4278 18.3332 27.5073V27.5073Z",
  fill: "#B42B28"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alertRed.3f24b4753e8908d664060ba71ca70cd6.svg";